function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var TajikistanFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_621_1132",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "3",
    width: "24",
    height: "18",
    children: /*#__PURE__*/_jsx("rect", {
      y: "3",
      width: "24",
      height: "18",
      fill: "white"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_1132)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3H24V21H0V3Z",
      fill: "#F7FCFF"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3V9H24V3H0Z",
      fill: "#C51918"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 15V21H24V15H0Z",
      fill: "#409100"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.959 14.683C11.6495 14.6919 11.4434 14.3649 11.4434 14.3649L11.7607 14.2832C11.7804 14.074 11.9239 13.9627 11.9239 13.9627C12.0188 14.0237 12.1213 14.2984 12.1213 14.2984L12.3932 14.3366C12.3932 14.3366 12.2685 14.6741 11.959 14.683ZM10.4479 14.7765C10.1427 14.8284 9.89305 14.5333 9.89305 14.5333L10.1959 14.4082C10.1863 14.1983 10.3129 14.0681 10.3129 14.0681C10.4154 14.1153 10.5551 14.3731 10.5551 14.3731H10.8296C10.8296 14.3731 10.7532 14.7247 10.4479 14.7765ZM9.36224 15.0736L9.5005 15.5659C10.2176 15.3719 11.0499 15.2743 11.9973 15.2743C12.9447 15.2743 13.7771 15.3719 14.4942 15.5659L14.6324 15.0736C13.8674 14.8666 12.9891 14.7637 11.9973 14.7637C11.0056 14.7637 10.1273 14.8666 9.36224 15.0736ZM14.0551 14.5843C14.0551 14.5843 13.8054 14.8794 13.5002 14.8275C13.195 14.7757 13.1185 14.4241 13.1185 14.4241H13.393C13.393 14.4241 13.5328 14.1663 13.6352 14.1191C13.6352 14.1191 13.7618 14.2493 13.7522 14.4592L14.0551 14.5843Z",
      fill: "#FFBB00"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.9689 13.274C11.9689 13.274 11.6172 14.079 11.0632 14.1412C10.5092 14.2035 10.2278 13.6834 10.2278 13.6834C10.2278 13.6834 10.1915 14.2243 9.5336 14.4327C8.87568 14.6412 8.52924 13.8083 8.52924 13.8083C8.52924 13.8083 8.87176 14.1147 9.40301 13.9811C9.93427 13.8476 10.144 13.3546 10.144 13.3546C10.144 13.3546 10.5371 13.8686 11.0632 13.6116C11.5892 13.3546 11.8802 13.0405 11.8802 12.7391V11.8377C11.8802 11.8377 11.7445 11.604 11.5091 11.604C11.2737 11.604 11.208 11.7697 11.208 11.7697C11.208 11.7697 11.1161 10.8319 11.9628 10.774L11.9628 10.7717L11.9862 10.7726L12.0096 10.7717L12.0096 10.774C12.8563 10.8319 12.7644 11.7697 12.7644 11.7697C12.7644 11.7697 12.6987 11.604 12.4633 11.604C12.2278 11.604 12.0921 11.8377 12.0921 11.8377V12.7391C12.0921 13.0405 12.3831 13.3546 12.9092 13.6116C13.4352 13.8686 13.8284 13.3546 13.8284 13.3546C13.8284 13.3546 14.0381 13.8476 14.5693 13.9811C15.1006 14.1147 15.4431 13.8083 15.4431 13.8083C15.4431 13.8083 15.0967 14.6412 14.4388 14.4327C13.7808 14.2243 13.7445 13.6834 13.7445 13.6834C13.7445 13.6834 13.4632 14.2035 12.9092 14.1412C12.3552 14.079 12.0035 13.274 12.0035 13.274L11.9862 12.2116L11.9689 13.274ZM11.9611 11.0264C11.5705 11.0264 11.4914 11.3571 11.4914 11.3571C11.8353 11.3571 11.9611 11.507 11.9611 11.507C11.9611 11.507 12.2158 11.3571 12.4722 11.3571C12.4722 11.3571 12.3517 11.0264 11.9611 11.0264Z",
      fill: "#FFBB00"
    }), /*#__PURE__*/_jsx("path", {
      d: "M8.92541 12.7489L7.43088 12.8768C7.3215 11.5992 7.84734 10.3905 8.95246 9.28302C10.5781 7.6538 13.8702 7.8125 15.2714 9.29816C16.0721 10.147 16.4821 11.3231 16.5216 12.7927L15.0221 12.833C14.9919 11.7072 14.7046 10.8833 14.1803 10.3274C13.3443 9.44112 11.0253 9.32932 10.0143 10.3425C9.20121 11.1574 8.85691 11.9487 8.92541 12.7489Z",
      fill: "#FFBB00"
    })]
  })]
}));
//# sourceMappingURL=Tajikistan.js.map